import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { PageMainLabel } from 'app/components/SHLabel';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDebounce } from 'hooks/useDebounce';
import UserTable from './UserTable';
import useUserApi from 'admin/hooks/useUserApi';
import { useNavigateToRoute } from 'utils/common';
import { CommonLoader } from 'app/components/CommonLoader';
import { usePermission } from 'hooks/usePermission';
import AdminDropDown from 'app/components/AdminDropDown';
import { GeneralLookup } from 'services/openapi';
const UserPage = () => {
  const breadCrumpitems = [
    {
      id: '',
      text: 'Showyeda admin',
      disabled: true,
    },
    {
      id: '',
      text: 'Users',
      disabled: true,
    },
  ];
  const {
    fetchManageGetUser,
    userProfileData,
    loading,
    deleteUser,
    handleDownloadUser,
    downloadLoading,
  } = useUserApi();
  const { hasViewPermission } = usePermission();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [active, setActive] = useState(true);
  const redirect = useNavigateToRoute();
  const [pageSkip, setPageSkip] = useState<number | undefined>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [pageSizeSelected, setPageSizeSelected] = useState<GeneralLookup>({
    id: '50',
    name: '50',
  });
  const pageSizeOptions: GeneralLookup[] = [
    { id: '25', name: '25' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
  ];
  const debounceUserSearch = useDebounce(searchTerm);
  const [sortField, setSortField] = useState<string>('name');
  const [sortOrder, setSortOrder] = useState<number>(0);
  const handleSearch = e => {
    setSearchTerm(e.target.value);
  };
  const handlePageSizeChange = (data: GeneralLookup) => {
    const newPageSize = parseInt(data.id, 10);
    setPageSize(newPageSize);
    setPageSizeSelected(data);
    setPageSkip(0);
    fetchManageGetUser(
      debounceUserSearch,
      sortField,
      sortOrder,
      0,
      newPageSize,
    );
  };
  const handleUserDwoload = async () => {
    try {
      const url: any = await handleDownloadUser(
        debounceUserSearch,
        sortField,
        sortOrder,
      );

      // Extract filename from URL
      const filename = url.split('/').pop();

      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = filename!; // Use the extracted filename

          // Append link to body (required for Firefox)
          document.body.appendChild(link);

          // Trigger download
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);
        })
        .catch(error => {
          console.error('Error downloading file:', error);
        });

      return url;
    } catch (error) {
      console.error('Error downloading team point report:', error);
      throw error;
    }
  };
  useEffect(() => {
    if (debounceUserSearch.length > 0) {
      fetchManageGetUser(debounceUserSearch, sortField, sortOrder, 0, pageSize);
    } else {
      fetchManageGetUser(
        debounceUserSearch,
        sortField,
        sortOrder,
        pageSkip,
        pageSize,
      );
    }
    if (pageSkip !== 0) {
      if (debounceUserSearch?.length! >= 0) {
        setPageSkip(0);
      }
    }
  }, [debounceUserSearch]);
  return (
    <>
      <CommonPageWrapper>
        {downloadLoading && <CommonLoader loaderType="main" />}
        <HeadingWrapper>
          <PageMainLabel>Users</PageMainLabel>
          <CustomBreadCrumb preData={breadCrumpitems} />
        </HeadingWrapper>
        <HeadingWrapper>
          <ButtonWrapper>
            {hasViewPermission('0100101002') ? (
              <AdminCustomButton
                buttonType="primary"
                isActive={false}
                className="fill-button"
                onClick={() => {
                  setActive(!active);
                  redirect(`/admin/users/create`);
                }}
              >
                Add New User
              </AdminCustomButton>
            ) : null}
          </ButtonWrapper>
          <div className="search-wrapper">
            <AdminCustomButton
              buttonType="primary"
              isActive={false}
              className="fill-button"
              onClick={handleUserDwoload}
              disabled={userProfileData?.users?.length === 0}
            >
              Download
            </AdminCustomButton>

            <div style={{ width: '283px', paddingTop: '30px' }}>
              <AdminSearch
                placeholder="Search by name"
                onSearchTextEntering={handleSearch}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </HeadingWrapper>
        {(userProfileData?.pageDetails?.count ?? 0) > 10 && (
          <EntriesPerPageDropDownWrapper>
            <AdminDropDown
              label="No: of entries per page"
              onDataChange={(data: GeneralLookup) => {
                handlePageSizeChange(data);
              }}
              defaultValue={pageSizeSelected}
              data={pageSizeOptions}
            />
          </EntriesPerPageDropDownWrapper>
        )}
        {/* User Table */}
        {hasViewPermission('0100101001') && (
          <UserTable
            setPageSkip={setPageSkip}
            pageSkip={pageSkip}
            pageSize={pageSize}
            debounceUserSearch={debounceUserSearch}
            fetchManageGetUser={fetchManageGetUser}
            userProfileData={userProfileData}
            deleteUser={deleteUser}
            sortField={sortField}
            sortOrder={sortOrder}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            loading={loading}
          />
        )}
      </CommonPageWrapper>
    </>
  );
};
export default UserPage;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 30px 0 0;
`;

const EntriesPerPageDropDownWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0 0;
  .SHdropdown {
    width: 160px;

    .label {
      margin-bottom: 8px;
      font-size: 13px;
      color: #475467;
      font-weight: 500;
    }

    .k-dropdownlist {
      max-height: 38px;
      border-radius: 8px !important;
    }

    .k-input-inner {
      padding: 0 8px !important;
      font-size: 13px;
    }

    .k-input-value-text {
      margin: 4px 0;
      font-size: 13px !important;
      color: #1e1e1e;
    }
  }
`;
